import React, { useState } from "react";
import "./Navbar.css"; // External CSS for styling

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <nav className="navbar">
      <div className={`menu ${isOpen ? "open" : ""}`}>
        <a href="http://piper-ears.web.app" target="_blank" rel="noopener noreferrer">Ear Training</a>
        <a href="http://piper-keys.web.app" target="_blank" rel="noopener noreferrer">Key Signatures</a>
        <a href="http://piper-extras.web.app" target="_blank" rel="noopener noreferrer">Printable Worksheets</a>
        <a href="http://piper-extras.web.app" target="_blank" rel="noopener noreferrer">Videos</a>
        <a href="#about-section">About Me</a>
        <a href="#contact">Contact</a>
      </div>
      <div className="hamburger" onClick={toggleMenu}>
        ☰
      </div>
    </nav>
  );
};

export default Navbar;
